import { Role, ICurrentUser } from '@api'
import { IPermissionsOnFloor } from './types'

const isSpaceCaptain = (role: Role) => role === Role.SPACE_CAPTAIN

function canLocationAdminManageFloor(user: ICurrentUser, floor?: { id: string }) {
  if (!floor) return false

  return Boolean(user.employee.locationAdmins.find(({ floorPlan }) => floor?.id === floorPlan.id))
}

export function onFloor(user: ICurrentUser, floor?: { id: string }): IPermissionsOnFloor {
  const permissions = {
    canUpdate: true,
    canDelete: true,
    canHide: true,
    canCreateNeighborhood: true,
    canDeleteNeighborhood: true,
    canUpdateNeighborhood: true,
  }

  if (
    user.isSuperUser ||
    user.employee.role === Role.ADMIN ||
    user.employee.role === Role.POWER_ADMIN
  )
    return permissions

  if (user.employee.role === Role.LOCATION_ADMIN || isSpaceCaptain(user.employee.role)) {
    const canManage = canLocationAdminManageFloor(user, floor)

    return {
      ...permissions,
      canDelete: false,
      canUpdate: canManage,
      canHide: canManage,
      canCreateNeighborhood: canManage,
      canDeleteNeighborhood: canManage,
      canUpdateNeighborhood: canManage,
    }
  }

  if (user.employee.role === Role.DEPARTMENT_ADMIN) {
    return {
      ...permissions,
      canDelete: false,
      canUpdate: false,
      canHide: false,
      canCreateNeighborhood: true,
      canDeleteNeighborhood: false,
      canUpdateNeighborhood: true,
    }
  }

  return {
    canUpdate: false,
    canDelete: false,
    canHide: false,
    canCreateNeighborhood: false,
    canDeleteNeighborhood: false,
    canUpdateNeighborhood: false,
  }
}
